import { Component } from 'react';
import { useRouteError } from 'react-router';
import Button from '../components/Button.jsx';
import styles from './ErrorBoundary.module.scss';

function Fallback({ error }) {
  return (
    <div className={styles.wrap}>
      <h1>Something went wrong</h1>
      <p>Your cards are safe — everything is stored on this device and in your backups.</p>
      <pre className={styles.detail}>{String(error?.message ?? error)}</pre>
      <div className={styles.actions}>
        <Button variant="primary" onClick={() => window.location.assign('/')}>
          Go home
        </Button>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    </div>
  );
}

export function RouteError() {
  const error = useRouteError();
  return <Fallback error={error} />;
}

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    if (this.state.error) return <Fallback error={this.state.error} />;
    return this.props.children;
  }
}
